










import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';

/**
 * Allows to configure an value offset
 */
@Component
export default class AmetrasPaginationTemplate extends Vue {
    @Prop() offset!: number;
    @Prop() value!: number;
    @Prop() length!: number;
    internalValue: number = 0;

    created() {
        this.internalValue = this.value + this.offset;
    }

    @Watch('value') modelChanges(newValue: number) {
        this.internalValue = newValue + this.offset;
    }

    captureInput(newValue: number) {
        this.$emit('change', {page: newValue - this.offset});
    }
}
